<template>
  <div>
    <div v-if="!homePage" id="mainContainer"></div>
    <div class="home-container" v-else>
      <component :is="selectedTemplate" :homeImage="homeImage" :exhibitIdProps="exhibitId" @exit="exitHomePage"></component>
    </div>

    <q-dialog v-model="showDialog" full-width full-height>
      <q-card style="background: linear-gradient(to right, midnightblue, black);">
        <q-btn @click="showDialog = false" round class="absolute-top-right q-mr-md q-mt-md bg-white"> <q-icon size="2rem"
            name="close" rounded /></q-btn>
        <div>
          <div class="resourceContainer">
            <img :src="selectedResource.imageUrl" alt="Selected Resource"
              style="height: 100%; max-height: 90vh; width:auto; margin-right: 10px;">

              <div v-if="selectedResource.description && selectedResource.description !== 'undefined'" class="description" style="max-width: 30%; padding: 20px; overflow-y: auto; color: white;">
              {{ selectedResource.description }}
            </div>
          </div>

        </div>
      </q-card>
    </q-dialog>
  </div>
  
</template>

<script>
import { ref, onMounted } from "vue";
import axios from "axios";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import Modele_2 from "../../components/Models/Modele_2.vue";
import Modele_3 from "../../components/Models/Modele_3.vue";
import Modele_1 from "../../components/Models/Modele_1.vue";
import Modele_4 from "../../components/Models/Modele_4.vue";
import Modele_5 from "../../components/Models/Modele_5.vue";
import Modele_6 from "../../components/Models/Modele_6.vue";
import Modele_7 from "../../components/Models/Modele_7.vue";
import { useRoute } from "vue-router";
import Konva from "konva";

gsap.registerPlugin(ScrollTrigger);

export default {
  layout: "default",
  components: {
    Modele_2,
    Modele_3,
    Modele_1,
    Modele_4,
    Modele_5,
    Modele_6,
    Modele_7
  },
  props: [
    'homePageProps',
    'exhibitId'
  ],
  setup(props) {
    const route = useRoute();
    const id = ref(route.params.id ?? props.exhibitId);
    const resources = ref([]);
    const name = ref("");
    const userName = ref("");
    const headImage = ref([]);
    const selectedTemplate = ref("");
    const homePage = ref(props.homePageProps == false && props.exhibitId ? false : true);
    const homeImage = ref({});
    var showDialog = ref(false);
    var selectedResource = ref(null);

    const getHeadImage = async (index) => {
      let url = `${process.env.VUE_APP_BASEURL}/s3Resource/${resources.value[index].name}`;
      let response = await axios.get(url);
      return response.data;
    };

    const getImage = async (name) => {
      try {
        var url = `${process.env.VUE_APP_BASEURL}/s3Resource/${name}`;
        var response = await axios.get(url);

        return response.data;
      } catch (error) {
        console.log(error)
      }




    };

    const getUserName = async () => {
      let url = `${process.env.VUE_APP_BASEURL}/user/${id.value}`;
      let response = await axios.get(url);
      userName.value = response.data.name;
    };

    const getHomeImage = async () => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/exhibit_home/${id.value}`;
        let response = await axios.get(url);
        homeImage.value = response.data[0];
      } catch (error) {
        console.error(error);
      }
    };

    const getModel = async () => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/model/${id.value}`;
        let response = await axios.get(url);
        if (response.data.length > 0) {
          selectedTemplate.value = response.data[0].model;
          selectedTemplate.value = selectedTemplate.value.replace(/è/g, 'e').replace(/\s+/g, '_');
        }
      } catch (error) {
        console.error(error);
      }
    };

    const exitHomePage = () => {
      homePage.value = false;
      setTimeout(() => {
        createKonva();
      }, 2000)
    };

    const getExhibitName = async () => {
      let url = `${process.env.VUE_APP_BASEURL}/exhibit/${id.value}`;
      let response = await axios.get(url);
      name.value = response.data.exhibit_name;
    };


    const getResources = async () => {
      let exhibitId = id.value;

      try {
        // Obtenir les ressources de l'exposition
        let resourcesUrl = `${process.env.VUE_APP_BASEURL}/resources`;
        let response = await axios.post(resourcesUrl, { exhibitId });
        let allResources = response.data;

        // Obtenir les resource_id de gallery_resource
        let galleryUrl = `${process.env.VUE_APP_BASEURL}/galleryResources/${exhibitId}`;
        let galleryResponse = await axios.get(galleryUrl);
        let galleryResourceIds = galleryResponse.data.map(res => res.resource_id);

        // Filtrer les ressources pour ne garder que celles présentes dans gallery_resource
        resources.value = allResources.filter(resource =>
          galleryResourceIds.includes(resource.id)
        );
      } catch (error) {
        console.error("Error fetching resources:", error);
      }
    };


    const createKonva = () => {
      console.log("window.innerWidth", window.innerWidth)
      var width = window.innerWidth;
      var height = window.innerHeight;
      //Stage konva
      var stage = new Konva.Stage({
        container: "mainContainer",
        width: width,
        height: height,
        draggable: true,
      })
      var layer = new Konva.Layer();
      stage.container().style.backgroundColor = 'black';
      const gradientRect = new Konva.Rect({
        x: 0,
        y: 0,
        width: window.innerWidth,
        height: window.innerHeight,
        fillLinearGradientStartPoint: { x: 0, y: 0 },
        fillLinearGradientEndPoint: { x: window.innerWidth, y: window.innerHeight },
        fillLinearGradientColorStops: [0, '#001F3F', 1, '#000000']
      });



      layer.add(gradientRect);
      stage.add(layer);
      const exhibitionTitle = new Konva.Text({
        x: 0,
        y: 20,
        text: name.value,
        fontSize: 20,
        fontFamily: 'Arial',
        fill: 'white',
        align: 'right',
        zIndex: 9999,
      });

      layer.add(exhibitionTitle);
      stage.on('dragmove', function () {
        const pos = stage.position();
        gradientRect.position({ x: -pos.x, y: -pos.y });
        layer.batchDraw(); // Redessine la couche pour refléter les changements
      });

      stage.container().style.cursor = 'move'

      addResourcesOnCanva(layer, stage)
    }

    function getNextPosition() {
      const x = currentCol * (IMAGE_WIDTH + HORIZONTAL_GAP);
      let y = currentRow * OFFSET;

      // Si la colonne est impaire, décalez vers le bas pour obtenir l'effet en quinconce
      if (currentCol % 2 !== 0) {
        y += IMAGE_HEIGHT / 2;
      }

      // Si la position x dépasse la largeur du canvas, passez à la ligne suivante
      if (x + IMAGE_WIDTH > CANVAS_WIDTH) {
        currentRow++;
        currentCol = 0;
      } else {
        currentCol++;
      }

      return { x, y };
    }


    const CANVAS_WIDTH = 3000;
    //const CANVAS_HEIGHT = 2000;
    const IMAGE_WIDTH = 250; // Supposons que chaque image ait une largeur de 150 pixels
    var IMAGE_HEIGHT = 150;
    const HORIZONTAL_GAP = 50; // Espace horizontal entre les images
    const VERTICAL_GAP = 150; // Espace vertical entre les images
    const OFFSET = IMAGE_HEIGHT + VERTICAL_GAP; // L'offset total vertical pour chaque nouvelle ligne
    let currentRow = 0;
    let currentCol = 0;
    const TITLE_HEIGHT = 40; // Hauteur du rectangle du titre
    //const TITLE_PADDING = 10; // Espace entre le texte et le bord du rectangle


    const addResourcesOnCanva = async (layer, stage) => {
      resources.value.map(async resource => {
        const img = new Image();
        img.onload = async () => {
          const aspectRatio = img.width / img.height;
          const scaledHeight = IMAGE_WIDTH / aspectRatio;
          const position = getNextPosition();
          const konvaImage = new Konva.Image({
            image: img,
            x: position.x,
            y: position.y,
            width: IMAGE_WIDTH,
            height: scaledHeight
          });
          layer.add(konvaImage);

          // Création du rectangle pour le titre
          const titleRect = new Konva.Rect({
            x: position.x,
            y: position.y + scaledHeight, // Placez le rectangle du titre juste sous l'image
            width: IMAGE_WIDTH,
            height: TITLE_HEIGHT,
            fill: 'rgba(0,0,0,0.0)',  // Fond semi-transparent
            stroke: 'white',
            strokeWidth: 2,
            opacity: 1
          });

          konvaImage.on('mouseenter', function () {
            stage.container().style.cursor = 'zoom-in'

          });

          konvaImage.on('mouseout', function () {
            stage.container().style.cursor = 'move'
          });

          konvaImage.on('click', async () => {
            selectedResource.value = {
              title: resource.title,
              description: resource.description,
              imageUrl: await getImage(resource.name)
            };
            showDialog.value = true;
          });


          layer.add(titleRect);

          // Ajout du texte pour le titre
          /*const titleText = new Konva.Text({
            x: position.x + TITLE_PADDING,
            y: position.y + scaledHeight + (TITLE_HEIGHT / 2) - 4, // Centre verticalement
            text: resource.title.toUpperCase(),
            fontSize: 16,
            fill: 'white',
            width: IMAGE_WIDTH - 2 * TITLE_PADDING, // Enlevez le padding des deux côtés
            align: 'center',
            fontFamily: 'Roboto, sans-serif',

          });*/

          //layer.add(titleText);
          layer.draw();  // Dessine le layer à nouveau pour afficher l'image
        };
        img.src = await getImage(resource.name)
      });
    }

    onMounted(async () => {
      await getResources();
      await getExhibitName();
      await getUserName();
      await getHomeImage();
      await getModel();
      if(homePage.value == false && props.exhibitId) {
        createKonva();
      }
    });

    function isImage(name) {
      const extension = name.split(".").pop().toLowerCase();
      return ["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(extension);
    }

    function isVideo(name) {
      const extension = name.split(".").pop().toLowerCase();
      return ["mp4", "webm", "avi", "mov", "mkv"].includes(extension);
    }

    return {
      resources,
      name,
      userName,
      headImage,
      selectedTemplate,
      homePage,
      homeImage,
      showDialog,
      selectedResource,
      getHeadImage,
      exitHomePage,
      isImage,
      isVideo
    };
  }
};
</script>

<style scoped>
.description {
  color: white;
  text-align: center;
}

.resourceContainer {
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
  
